export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/back-arrow.b9e8a391-8175bc.svg";